import { IAttachment,
         AttachmentTypeEnum }                      from '.';


/**
 * Define attachment entity to trigger the request of feedback score.
 */
export class AttachmentFeedbackScoreEntity implements IAttachment {
    public attId!: string;
    public type!: AttachmentTypeEnum;

    /**
     * Constructor
     * 
     * @param id - The associated feedback request unique identifier
     */
    constructor(private id: string) {

                    this.type = AttachmentTypeEnum.FEEDBACK_SCORE;
                    this.attId = `feedback-score-${this.id}`;
                }
}
